import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";


@Injectable({ providedIn: 'root' })
export class ShopifyService {

  backendUrl: string = environment.apiUrl;
  url_final: string

  constructor(private http: HttpClient) {
    
  }

  pasar_params(code, shop, state, user_id) {
    this.url_final = this.backendUrl + "/shopify_integration?shop=" 
    this.url_final = `${this.url_final}${shop}&code=${code}&state=${state}&user_id=${user_id}`;
    return this.http.get<any>(this.url_final, {observe: 'response'})
    .pipe(map(response => {
      // console.log("la api es");
      // console.log(response)
      return response;
    }));
  }

  desvincularShopify(opcion){
    this.url_final = this.backendUrl + "/rmsfe/desvincular_shopify"
    this.url_final = `${this.url_final}`;
    return this.http.post<any>(this.url_final, { opcion})
    .pipe(map(response => {
      // console.log("la api es");
      // console.log(response)
      return response;
    }))
  }

}